import { render, staticRenderFns } from "./DebtorItem.vue?vue&type=template&id=82295a9c"
import script from "./DebtorItem.vue?vue&type=script&lang=js"
export * from "./DebtorItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports